import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, PLATFORM_ID, TransferState} from '@angular/core';
import { BrowserModule, provideClientHydration} from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient } from "@angular/common/http";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {I18nModule} from "@app/i18n";
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {RedirectPrefixComponent} from "@app/routing-lang/redirect-prefix/redirect-prefix.component";
import {HandlerRedirectToLanguageComponent} from "@app/routing-lang/handler-redirect-to-language/handler-redirect-to-language.component";
import { HomeModule } from "@app/home/home.module";
import { SideNavModule } from "@app/side-nav/side-nav.module";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from "@shared/shared.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule} from "@core/core.module";
import {SecurityModule} from "@app/security/security.module";
import {FacebookService} from "@shared/services/api/facebook.service";
import {environment} from "@env/environment";
import {PagesModule} from "@app/pages/pages.module";
import { LandingInversoresModule } from './landing-inversores/landing-inversores.module';
import {InitGoogleMapsService} from "@shared/services/api/init-google-maps.service";
import { TranslateUniversalLoader } from './translate-universal.loader';

/*
  export function HttpLoaderFactory(http: HttpClient) {
    return new CustomTranslateHttpLoader(http);
  }
*/

export function HttpLoaderFactory(http: HttpClient, transferState: TransferState, platformId: Object) {
  return new TranslateUniversalLoader(http, transferState, platformId);
}

export function initTranslations(translate: TranslateService, platformId: Object): () => Promise<any> {
  return () => {
    translate.setDefaultLang('es');
    const lang = isPlatformBrowser(platformId) && window.location.pathname.includes('/en/') ? 'en' : 'es';
    return firstValueFrom(translate.use(lang));
  };
}


@NgModule({
  declarations: [
    AppComponent,
    RedirectPrefixComponent,
    HandlerRedirectToLanguageComponent
  ],
    imports: [
        CommonModule,
        CoreModule,
        TranslateModule.forRoot(
            {
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    //deps: [HttpClient]
                     deps: [HttpClient, TransferState, PLATFORM_ID]
                }
            }),
        AppRoutingModule,
        I18nModule,
        //BrowserModule.withServerTransition({appId: 'serverApp'}),
        BrowserModule,
        BrowserAnimationsModule,
        HomeModule,
        SideNavModule,
        MatSidenavModule,
        MatIconModule,
        SharedModule,
        SecurityModule,
        ReactiveFormsModule,
        FormsModule,
        PagesModule,
        LandingInversoresModule
    ],
  exports: [
      HandlerRedirectToLanguageComponent
  ],
  providers: [
    provideClientHydration(),
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslations,
      deps: [TranslateService, PLATFORM_ID],
      multi: true
    },
    FacebookService,
    InitGoogleMapsService,
    {
      provide: APP_INITIALIZER,
      useFactory: (facebookService: FacebookService) => {
        return () => facebookService.initFacebookSDK( environment.FACEBOOK_APP_ID, 'v17.0');
      },
      deps: [FacebookService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (gmapService: InitGoogleMapsService) => {
        return () => gmapService.initGoogleMaps( environment.GOOGLE_MAP_API_KEY);
      },
      deps: [InitGoogleMapsService],
      multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
